module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-1.98043e5c.jpg";